var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drawer-area"},[_c('div',{staticClass:"drawer"},[_c('Vuescroll',{attrs:{"ops":_vm.ops}},[_vm._t("drawer")],2)],1),_c('div',{staticClass:"page"},[_vm._t("page")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }